const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "arivu_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

async function request(path, { method = "GET", body, auth = false } = {}) {
  const headers = { "Content-Type": "application/json" };
  if (auth) headers["Authorization"] = `Bearer ${getToken()}`;
  const res = await fetch(`${API}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  let data = null;
  try {
    data = await res.json();
  } catch {
    data = null;
  }
  if (!res.ok) {
    const err = new Error("Request failed");
    err.status = res.status;
    err.detail = data?.detail;
    throw err;
  }
  return data;
}

export async function adminLogin(email, password) {
  const data = await request("/auth/login", { method: "POST", body: { email, password } });
  setToken(data.access_token);
  return data.user;
}

export async function fetchMe() {
  return request("/auth/me", { auth: true });
}

export async function fetchContacts() {
  return request("/admin/contacts", { auth: true });
}

export async function fetchSubscribers() {
  return request("/admin/subscribers", { auth: true });
}

export async function fetchStats() {
  return request("/admin/stats", { auth: true });
}

// ---------- Blog ----------
export async function fetchBlogPosts() {
  return request("/blog");
}

export async function fetchBlogPost(slug) {
  return request(`/blog/${slug}`);
}

export async function fetchAdminPosts() {
  return request("/admin/posts", { auth: true });
}

export async function createPost(data) {
  return request("/admin/posts", { method: "POST", body: data, auth: true });
}

export async function updatePost(id, data) {
  return request(`/admin/posts/${id}`, { method: "PATCH", body: data, auth: true });
}

export async function deletePost(id) {
  return request(`/admin/posts/${id}`, { method: "DELETE", auth: true });
}

export async function fetchNewsletterHtml(id) {
  const res = await fetch(`${API}/admin/posts/${id}/newsletter-html`, {
    headers: { Authorization: `Bearer ${getToken()}` },
  });
  if (!res.ok) throw new Error("failed");
  return res.text();
}
